import { render } from "./new-company.vue?vue&type=template&id=51126515"
import script from "./new-company.vue?vue&type=script&lang=js"
export * from "./new-company.vue?vue&type=script&lang=js"

import "./new-company.vue?vue&type=style&index=0&id=51126515&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__